export enum EmojiType {
  DEFAULT = 'default',
  GLOBAL = 'global',
  JAPAN = 'japan'
}
